<template>
  <div>
      <div v-if="redirectUrl">
        <div class="grid-x grid-padding-x align-center">
          <div class="cell text-center confirm">
              <i class="material-icons">check_circle</i>
              <h3>
                {{ $t('label.passwordChanged') }}
              </h3>
              <p>
                {{ $t('label.loginAt') }} <br />
                <a v-bind:href="redirectUrl" class="link-underline">
                  {{redirectUrl}}
                </a>
              </p>
          </div>
        </div>
      </div>
      <div v-if="!redirectUrl">
        <div class="grid-x grid-padding-x align-center" v-if="mail">
            <div class="cell">
                <h5>{{ $t('label.resetPassword') }}</h5>
                <h6 class="mail-to">Email: {{mail}}</h6>
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center" v-if="mail">
            <div class="cell">
                <input type="password" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.newPassword')" v-model="password">
            </div>
        </div>
        <div class="grid-x grid-padding-x align-center" v-if="mail">
            <div class="cell">
                <input type="password" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.confirmPassword')" v-model="password_confirm">
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12" v-if="mail">
                <span class="messageError beebeeLabel">{{error}}</span>
            </div>
        </div>
        <div class="grid-x grid-padding-x align-center" v-if="mail">
            <div class="cell small-12 medium-6">
                <button class="button button-default expanded hovering ld-over" type="submit" v-on:click="resetPwd" v-bind:class="running ? 'running' : ''">
                  {{ $t('label.changePassword') }}
                  <div class="ld ld-ball ld-flip"></div>
                </button>
            </div>
            <div class="cell small-12 medium-6 text-right sideButton">
              <router-link to="/" class="link-underline">
                {{ $t('label.backLogin') }}
              </router-link>
            </div>
        </div>
      </div>

      <div v-if="invalid">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell text-center">
                <h5>{{ $t('label.invalidSession') }}</h5>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as CONFIG from '../config'

export default {
  name: 'reset',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    password: '',
    password_confirm: '',
    mail: null,
    error: '',
    redirectUrl: null,
    invalid: false,
    running: false
  }),
  created () {
    var self = this

    var token = this.token
    if (token) {
      axios.get(`${CONFIG.BASEURL}/api/v1/reset/${token}`)
      .then(res => {
        console.log(res.data)
        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.id) {
          console.log(res.data.data.user.mail)
          self.mail = res.data.data.user.mail
        }
      })
      .catch(function (reason) {
        self.invalid = true
      })
    }
  },
  methods: {

    resetPwd () {
      var self = this
      var token = this.token

      if (this.running) {
        return false
      }

      if (this.password === '' || this.password_confirm === '') {
        this.error = this.$t('label.emptyField')
        return false
      }

      if (this.password !== this.password_confirm) {
        this.error = this.$t('label.passwordNotMatch')
        return false
      }

      this.error = ''
      self.running = true

      axios.post(`${CONFIG.BASEURL}/api/v1/reset/${token}`, {
        'data': {
          'attributes': {
            'password': this.password
          }
        }
      }, {
        cache: false
      })
        .then(res => {
          self.running = false
          console.log(res)

          if (res && res.data && res.data.url && res.data.access_token) {
            this.$cookie.set('secure', res.data.access_token, {
              expires: parseFloat(res.data.access_token) / 60 / 60 / 24
            })
            self.redirectUrl = res.data.url
          } else {
            self.running = false
            if (typeof res.data.responseJSON.errors[0].detail !== 'undefined' && res.data.responseJSON.errors[0].detail) {
              self.error = res.data.responseJSON.errors[0].detail
            }
          }
        })
        .catch(function (reason) {
          self.running = false
          if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
            self.error = reason.response.data.errors[0].detail
          } else {
            self.error = self.$t('label.resetError')
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.mail-to {
	line-height: 50px;	
}

</style>



// WEBPACK FOOTER //
// src/components/Reset.vue